import React from 'react';
import { useForm, useFormState } from 'react-final-form';

import type { MultipleSelectToggleProps } from '../MultipleSelectToggle/MultipleSelectToggle';
import MultipleSelectToggle from '../MultipleSelectToggle/MultipleSelectToggle';

export type Props = Omit<MultipleSelectToggleProps, 'checked' | 'disabled' | 'onChange'> & {
  filterId: string;
  onToggleChange?: (checked: boolean) => void;
};

const MultipleSelectCustomRange: React.FC<React.PropsWithChildren<Props>> = ({
  id,
  filterId,
  classes,
  value,
  label,
  children,
  onToggleChange
}) => {
  const {
    values: { [id]: toggleValue, [filterId]: filterValue }
  } = useFormState();
  const { reset, batch, change } = useForm();

  const handleOnToggleChanged: MultipleSelectToggleProps['onChange'] = (_, checked) => {
    if (checked) {
      batch(() => {
        reset();
        change(id, checked);
        change(filterId, filterValue);
      });
    }
    onToggleChange?.(checked);
  };

  return (
    <>
      <MultipleSelectToggle
        id={id}
        value={value}
        label={label}
        classes={classes}
        onChange={handleOnToggleChanged}
      />
      {toggleValue && children}
    </>
  );
};

export default MultipleSelectCustomRange;
